export const SadieSimulatorEditedChip = () => (
  <span className="rounded-md bg-amber-50 px-1.5 py-0.5 text-[11px] font-medium text-amber-700">
    edited
  </span>
);
